import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  baseUrl: string = environment.baseUrl;
  constructor(
    private httpClient: HttpClient,
    
    private _toastrService: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  /**POST API's */

  getRequest(endPoint, reqBody) {
    return this.httpClient.get(`${this.baseUrl}${endPoint}`);
  }
  getRequestWithoutbody(endPoint) {
    return this.httpClient.get(`${this.baseUrl}${endPoint}`);
  }
  postRequestwithoutToken(endPoint, reqBody) {
    return this.httpClient.post(`${this.baseUrl}${endPoint}`, reqBody);
  }
  postRequest(endPoint, reqBody) {
    return this.httpClient.post(`${this.baseUrl}${endPoint}`, reqBody);
  }
  postRequestById(endPoint, reqBody) {
    return this.httpClient.post(`${this.baseUrl}${endPoint}`, reqBody);
  }

  putRequest(endPoint, reqBody) {
    return this.httpClient.put(`${this.baseUrl}${endPoint}`, reqBody);
  }

  deleteRequest(endPoint, reqBody) {
    return this.httpClient.delete(`${this.baseUrl}${endPoint}`);
  }

  header(isFormData) {
    if (
      localStorage.accessToken != undefined ||
      localStorage.accessToken != null
    ) {
      var headers;
      if (isFormData) {
        headers = new HttpHeaders({
          mimeType: 'multipart/form-data',
          authorization: localStorage.accessToken,
        });
      } else {
        headers = new HttpHeaders({
          'cache-control': 'no-cache',
          'content-type': 'application/json',
          // "mimeType": "multipart/form-data",
          authorization: localStorage.accessToken,
        });
      }
      let option = {
        headers,
      };

      option['observe'] = 'response';
      return option;
    }
  }

  successMsg(message) {
    this._toastrService.success(message, "", {
      closeButton: true,
      timeOut: 4000,
    });
  }

  errorMsg(message) {
    this._toastrService.error(message, "", {
      closeButton: true,
      timeOut: 4000,
    });
  }

  showSpinner() {
    console.log("show spinner");
    this.spinner.show();
  }

  hideSpinner() {
    console.log("hide spinner");
    this.spinner.hide();
  }

}
